mtl.alloy.factory['tabify'] = (function($) {
    'use strict';

    return function(element, options) {

        var $tabset = $(element);

        var $tabsetHeaders = $tabset.find('.tabset-headers');
        if (!$tabsetHeaders[0]) {
            $tabsetHeaders = $('<div class="tabset-headers"></div>').appendTo($tabset);
        }

        var $tabsetBodies = $tabset.find('.tabset-bodies');
        if (!$tabsetBodies[0]) {
            $tabsetBodies = $('<div class="tabset-bodies"></div>').appendTo($tabset);
        }

        $tabset.children('.tab').each(function() {
            var $tab = $(this);
            $tabsetHeaders.append($tab.find('.tab-header').addClass('tabified').clone());
            $tabsetBodies.append($tab.find('.tab-body').addClass('tabified').clone());
            $tab.addClass('tabified');
        });

        $tabset.addClass('tabified');

        var $headers = $tabsetHeaders.children();
        var $bodies = $tabsetBodies.children();

        /**
         * Show the tab/body and a given index.
         */
        function showIndex(index, instant, force) {

            if (!force && index === $headers.filter('.is-active').index()) {
                return;
            }

            $headers.removeClass('is-active')
                .eq(index).addClass('is-active');

            var $body = $bodies.stop(true, false).css({display: 'none'})
                .eq(index);

            // Instant transition
            if (instant) {
                $body.css({display: ''});
            }

            // Animated transition
            else {
                $body
                    .css({
                        opacity: 0,
                        display: ''
                    })
                    .animate({
                        opacity: 1
                    }, 200)
                ;
            }

        }


        /**
         * Click header event.
         */
        $tabset.on('click', '.tab-header', function(event) {

            showIndex($headers.index(this));

            event.preventDefault();

        });


        // Find and activate the default index
        var defaultIndex = Math.max(0, $headers.filter('.is-active').index());
        showIndex(defaultIndex, true, true);

    };

}(jQuery));
